import {AbstractInteractionMode, DrawStyleUtil} from "./abstract-interaction-mode";
import {BoundingBoxSimpleSelect} from "../interaction/bounding-box/bounding-box-simple-select";


export class BoundingBoxMode extends AbstractInteractionMode {
  static identifier: string = "bounding-box";
  static title: string = "Limite spațiale";
  static icon: string = "/icons/toolbox/gui-magic.svg";

  static drawStyles = DrawStyleUtil.drawStyle({
    "line-color": '#23B402',
    "border-color": '#23B402',
  });

  static interactions = {
    'select': BoundingBoxSimpleSelect.definition()
  }

  static allowChanges: boolean = false;
  static allowPriorityContextMenu: boolean = false;

  static showActionBar: boolean = false;

  onEnabled() {
    this.controller.mapInstance.on('draw.boxSelect', (e) => this.controller.mapInstance.fire('show-bbox', e));
  }
}
